import { SxProps, Theme } from '@mui/material';

export const IG_AUTO_BG = '#0e0e0e';
export const IG_AUTO_SURFACE = '#1a1919';
export const IG_AUTO_CARD = '#262626';
export const IG_AUTO_BORDER = 'rgba(255, 255, 255, 0.08)';
export const IG_AUTO_GOLD = '#ffc965';
export const IG_AUTO_MINT = '#00fdc1';
export const IG_AUTO_MUTED = '#adaaaa';
export const IG_AUTO_WHITE = '#ffffff';
export const IG_AUTO_RED = '#ff7351';

export const igAutoTextFieldSx: SxProps<Theme> = {
    '& .MuiOutlinedInput-root': {
        bgcolor: '#201f1f',
        color: IG_AUTO_WHITE,
        borderRadius: 1,
        fontSize: 14,
        '& fieldset': { borderColor: IG_AUTO_BORDER },
        '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
        '&.Mui-focused fieldset': { borderColor: 'rgba(255, 201, 101, 0.4)' },
        '&.Mui-disabled': {
            bgcolor: 'rgba(255,255,255,0.03)',
            color: 'rgba(255,255,255,0.38)',
            WebkitTextFillColor: 'rgba(255,255,255,0.38)',
            '& fieldset': {
                borderColor: 'rgba(255,255,255,0.12)',
                borderStyle: 'dashed',
            },
        },
    },
    '& .MuiOutlinedInput-input.Mui-disabled': {
        WebkitTextFillColor: 'rgba(255,255,255,0.38)',
        color: 'rgba(255,255,255,0.38)',
        opacity: 1,
    },
    '& .MuiInputLabel-root': { color: IG_AUTO_MUTED, fontSize: 12 },
    '& .MuiInputLabel-root.Mui-focused': { color: IG_AUTO_GOLD },
    '& .MuiInputLabel-root.Mui-disabled': {
        color: 'rgba(173,170,170,0.55)',
    },
    '& .MuiFormHelperText-root.Mui-disabled': {
        color: 'rgba(173,170,170,0.5)',
    },
};

export const igAutoGlassCardSx: SxProps<Theme> = {
    bgcolor: 'rgba(38, 38, 38, 0.4)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 201, 101, 0.05)',
    borderRadius: 2,
    p: 3,
};
